import(/* webpackMode: "eager" */ "/vercel/path0/app/(lobby)/settings/page.tsx");
